import React from 'react';
import { Box } from '@mui/material';

const DrawerContainer = ({ id = 'container-wrapper', children, sx, ...props }) => {
  return (
    <Box
      id={id}
      sx={{
        flex: '1 1 auto',
        minHeight: 0,
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: 5
        },
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default DrawerContainer;
